// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import EmailIcon from "@mui/icons-material/Email";
import InstagramIcon from "@mui/icons-material/Instagram";

// Material Kit 2 React components
import MKTypography from "components/MKTypography";

// Images

const logoSindicato = "https://i.pinimg.com/736x/40/a1/96/40a196969b2011a4cbf5dc4f37766a6f.jpg";

const date = new Date().getFullYear();

export default {
  brand: {
    name: "Sindicato Obreros Panaderos y Pasteleros de San Juan",
    image: logoSindicato,
    route: "/",
  },

  socials: [
    {
      icon: <FacebookIcon />,
      link: "https://www.facebook.com/p/Sindicato-de-Panaderos-y-Pasteleros-de-San-Juan-100083450346650/?locale=es_LA",
    },
    {
      icon: <InstagramIcon />,
      link: "https://www.instagram.com/sindicatodepanaderos/",
    },
    {
      icon: <EmailIcon />,
      link: "mailto:spanaderossanjuan@gmail.com",
    },
  ],
  menus: [
    {
      name: "Sindicato - Afiliados",
      items: [
        { name: "Escalas Salariales", href: "/escalassalariales" },
        { name: "Afiliate", href: "/afiliate" },
        { name: "Denuncias", href: "/denuncias" },
      ],
    },
    {
      name: "Sindicato - Empresas",
      items: [
        { name: "Registra trabajadores", href: "/registratrabajadores" },
        { name: "Afilia tu personal", href: "/afiliartrabajadores" },
        { name: "Estado de deuda", href: "/estadodeudaempresa" },
      ],
    },
    {
      name: "Afiliados",
      items: [
        { name: "Beneficios", href: "/beneficiosafiliados" },
        { name: "Actividades", href: "/actividadesafiliados?genero=todas" },
        { name: "Especializaciones", href: "/especializaciones" },
        { name: "Verano 2026", href: "/verano2026" },
      ],
    },
    {
      name: "Apoyo escolar 2026",
      items: [
        {
          name: "Formulario de pre inscripcion apoyo escolar",
          href: "/apoyo escolar",
        },
      ],
    },
  ],
  copyright: (
    <MKTypography variant="button" fontWeight="regular">
      Todos los derechos reservados &copy; {date} sitio creado por{" "}
      <MKTypography rel="noreferrer" variant="button" fontWeight="regular">
        Gerardo Escobar
      </MKTypography>
      .
    </MKTypography>
  ),
};
